<template>
    <ModalComponent
        :name="'borrar-' + comunicado.id"
        :title="'¿Seguro que quieres borrar el comunicado: ' + (comunicado.titulo ?? comunicado.whatsappTemplate?.name) + '?'"
        v-on:close="() => close(false)"
    >
        <div class="row">
            <div class="col-12">
                <h2>Datos del comunicado</h2>
            </div>
            <div class="col-12">
                <ul class="list-group list-group-unbordered mb-3">
                    <li class="list-group-item">
                        <b>Título:</b> {{ comunicado.titulo ?? comunicado.whatsappTemplate?.name }}
                    </li>
                    <li class="list-group-item">
                        <b>Asunto:</b> {{ comunicado.asunto }}
                    </li>
                    <li class="list-group-item">
                        <b>Fecha de envio:</b> {{ comunicado.fecha_envio }}
                    </li>
                    <li class="list-group-item">
                        <b>Listo para enviar:</b> {{ comunicado.listo_para_enviar ? 'Si': 'No' }}
                    </li>
                    <li class="list-group-item" v-if="comunicado.tipo === 2">
                        <b>Coste de envío del WhatsApp:</b> {{ comunicado.coste_envio_whatsapp | formatear_precio }}
                    </li>
                    <li class="list-group-item">
                        <b>Contenido:</b>
                        <span v-html="comunicado.contenido" v-if="comunicado.tipo === 1"></span>
                        <VistaPreviaComponent v-else :components="comunicado.whatsappTemplate?.components"/>
                    </li>
                </ul>
            </div>
            <div class="col-12 text-center">
                <h1 class="font-weight-bold">¿BORRAR COMUNICADO?</h1>
            </div>
            <div class="col-12 text-center">
                <Button type="button" name="button" @click="borrarComunicado">SI, BORRAR</Button>
            </div>
        </div>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";
    import VistaPreviaComponent from "@/components/backend/plantillas-whatsapp/VistaPreviaComponent";

    export default {
        props: ['comunicado'],
        data() {
            return {
                loading: false
            }
        },
        methods: {
            close(borrado) {
                this.$emit('close', 'borrar-' + this.comunicado.id, borrado);
            },
            borrarComunicado() {
                this.loading = true;

                const params = {
                    filters : {},
                    comunicado_id: this.comunicado.id
                }

                this.$store.dispatch(this.config.getVuexAlias('back.comunicados.borrar'), params).then(res => {
                    this.expand = [];
                    this.$toast.success(res.data.message);
                    this.close(true);
                }).finally(() => this.loading = false);
            }
        },
        components: {
            ModalComponent, VistaPreviaComponent
        }
    }
</script>
